var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFortuneWheel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 75,
    viewBox: "0 0 142 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_846_4161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71 133.818C108.003 133.818 138 103.862 138 66.9091C138 29.9562 108.003 0 71 0C33.9969 0 4 29.9562 4 66.9091C4 103.862 33.9969 133.818 71 133.818Z",
    fill: "#FFD04E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0003 129.804C104.673 129.804 131.97 102.544 131.97 68.9166C131.97 35.2895 104.673 8.0293 71.0003 8.0293C37.3275 8.0293 10.0303 35.2895 10.0303 68.9166C10.0303 102.544 37.3275 129.804 71.0003 129.804Z",
    fill: "#C59D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0002 127.128C104.303 127.128 131.3 100.167 131.3 66.9096C131.3 33.652 104.303 6.69141 71.0002 6.69141C37.6974 6.69141 10.7002 33.652 10.7002 66.9096C10.7002 100.167 37.6974 127.128 71.0002 127.128Z",
    fill: "#FFFFF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0003 66.9092L31.2023 106.653C26.3783 101.836 22.6263 96.483 19.9463 90.7288L71.0003 66.9092Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1484 117.894C53.1784 120.704 59.6104 122.31 66.0424 122.979L71.0004 66.9092L47.1484 117.894Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6065 121.239C91.9045 119.634 97.8005 116.823 103.294 112.943L71.0005 66.9092L85.6065 121.239Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7058 20.876C36.0258 22.7494 33.4798 24.7567 31.2018 27.1654C28.7898 29.5742 26.7798 31.9829 24.9038 34.6593L70.9998 66.9094L38.7058 20.876Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5962 52.3232C14.8542 58.6127 14.3182 65.3036 14.8542 71.7269L71.0002 66.9094L16.5962 52.3232Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9583 10.9731C69.3923 10.4378 62.8263 10.9731 56.5283 12.7127L71.0003 66.9091L75.9583 10.9731Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.798 27.1655C105.974 22.3481 100.614 18.6012 94.8525 15.9248L71.0005 66.9095L110.798 27.1655Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.096 99.1594C120.982 93.6728 123.662 87.651 125.404 81.4954L71.0005 66.9092L117.096 99.1594Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.012 61.9582C126.476 55.5349 124.734 49.1117 121.92 43.0898L71.0005 66.9095L127.012 61.9582Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0001 66.9092L47.1482 117.894C41.3862 115.218 35.8921 111.471 31.2021 106.653L71.0001 66.9092Z",
    fill: "#FD9A07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0425 122.845C72.6085 123.38 79.1745 122.845 85.4725 121.106L71.0005 66.9092L66.0425 122.845Z",
    fill: "#FD9A07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9883 71.8605C15.5243 78.2837 17.2663 84.707 20.0803 90.7288L71.0003 66.9092L14.9883 71.8605Z",
    fill: "#FD9A07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9042 34.6592C21.0182 40.1457 18.3382 46.1675 16.5962 52.3232L71.0002 66.9094L24.9042 34.6592Z",
    fill: "#FD9A07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.8525 15.924C88.8225 13.1138 82.3905 11.508 75.9585 10.8389L71.0005 66.9087L94.8525 15.924Z",
    fill: "#FD9A07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0001 66.9093L56.3941 12.5791C50.0961 14.1849 44.2001 16.9951 38.7061 20.8758L71.0001 66.9093Z",
    fill: "#FD9A07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.294 112.943C105.974 111.069 108.52 109.062 110.798 106.653C113.21 104.244 115.22 101.836 117.096 99.1594L71.0005 66.9092L103.294 112.943Z",
    fill: "#FD9A07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.404 81.4954C127.146 75.206 127.682 68.5151 127.146 62.0918L71.0005 66.9093L125.404 81.4954Z",
    fill: "#FD9A07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.054 43.0894C119.374 37.3352 115.622 31.8487 110.798 27.165L71.0005 66.909L122.054 43.0894Z",
    fill: "#FD9A07"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M127.28 66.9087C127.28 35.8629 102.088 10.7051 70.9997 10.7051C39.9117 10.7051 14.7197 35.8629 14.7197 66.9087C14.7197 77.6142 17.6677 87.6506 22.8937 96.0811C18.6057 88.3196 16.0597 79.22 16.0597 69.5851C16.0597 39.3422 40.7157 14.7196 70.9997 14.7196C101.284 14.7196 125.94 39.3422 125.94 69.5851C125.94 79.22 123.394 88.3196 119.106 96.0811C124.332 87.6506 127.28 77.6142 127.28 66.9087ZM85.0697 68.2469C85.0697 76.0084 78.7717 82.2978 70.9997 82.2978C63.2277 82.2978 56.9297 76.0084 56.9297 68.2469C56.9297 60.4855 63.2277 54.196 70.9997 54.196C78.7717 54.196 85.0697 60.4855 85.0697 68.2469Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.462 61.9571L73.412 36.3978C73.01 35.4611 72.072 34.6582 70.866 34.6582C69.66 34.6582 68.722 35.3273 68.32 36.3978L58.27 61.9571C57.734 63.4291 57.332 65.1688 57.332 66.7746C57.332 74.1346 63.362 80.1564 70.732 80.1564C78.102 80.1564 84.132 74.1346 84.132 66.7746C84.4 65.1688 84.132 63.4291 83.462 61.9571Z",
    fill: "#FFFFF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0003 77.4795C65.1043 77.4795 60.2803 72.662 60.2803 66.774C60.2803 65.4358 60.5483 64.0976 60.9503 62.8933L71.0003 37.334L81.0503 62.8933C81.5863 64.0976 81.7203 65.4358 81.7203 66.774C81.7203 72.7958 76.8963 77.4795 71.0003 77.4795Z",
    fill: "#FC680A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0001 72.1273C73.9604 72.1273 76.3601 69.7308 76.3601 66.7746C76.3601 63.8184 73.9604 61.4219 71.0001 61.4219C68.0399 61.4219 65.6401 63.8184 65.6401 66.7746C65.6401 69.7308 68.0399 72.1273 71.0001 72.1273Z",
    fill: "#FEBA09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0002 68.7821C72.1103 68.7821 73.0102 67.8834 73.0102 66.7748C73.0102 65.6663 72.1103 64.7676 71.0002 64.7676C69.8901 64.7676 68.9902 65.6663 68.9902 66.7748C68.9902 67.8834 69.8901 68.7821 71.0002 68.7821Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_846_4161"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 142,
    height: 86,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFortuneWheel);
export default __webpack_public_path__ + "static/media/fortune_wheel.5b5cb919ef5dfc05875045fef8711ca7.svg";
export { ForwardRef as ReactComponent };